import React from 'react';

const ProgressPage = () => (
  <div className="progress-page">
    <h3>This page is planning ...</h3>
    <i className="fas fa-pencil-ruler" />
  </div>
);


export default ProgressPage;
